module.exports = __webpack_public_path__ + "media/images/illustrations/online_photo_catalog_large-3d20e0ec9d6b28490809649072b8e792.svg";